import React from 'react'
import './Footer.sass'
import packageInfo from '../../../package.json'

const Footer: React.FC = () => {
    return (
        <div className="footer">
            <span>
                v{packageInfo.version} | {(packageInfo as any).credits}
            </span>
        </div>
    )
}

export default Footer
